import React from 'react';
import { useForm } from 'react-hook-form';
import { WebDevelopment } from '../../utils/formNames';
import { getFormData } from '../../utils/sessionStorage';
import { FORM_HOST } from '../../utils/constants';
import EnrollmentForm from './EnrollmentForm';
import EnrollmentFormInput from '../FormInputs/FormInput';
import EnrollmentFormError from '../FormInputs/FormError';

const formName = WebDevelopment;
const pardotFormUrl = `${FORM_HOST}/l/772833/2020-04-14/5c7126`;
const callbackLocations = {
  success_location: `${FORM_HOST}/l/772833/2020-07-06/7k97pn/772833/58617/web_development_success.js`,
  error_location: `${FORM_HOST}/l/772833/2020-07-06/7k97pl/772833/58615/web_development_error.js`,
};

const WebDevelopmentForm = () => {
  const { register, handleSubmit, formState, errors } = useForm({
    mode: 'onBlur',
    submitFocusError: false,
  });

  const previousData = getFormData(formName);

  return (
    <EnrollmentForm
      formName={formName}
      callbackLocations={callbackLocations}
      actionUrl={pardotFormUrl}
      formValid={formState.isValid}
      validationHandler={handleSubmit}
    >
      <legend>Web Development</legend>
      <EnrollmentFormInput
        name="webdev_project"
        type="url"
        label="Please submit a link to a recent web development project."
        placeholder="http://yourwebsite.com/"
        defaultValue={previousData.webdev_project}
        inputRef={register}
        error={errors.webdev_project}
      />
      <EnrollmentFormError errorField={errors.webdev_project} />
    </EnrollmentForm>
  );
};

export default WebDevelopmentForm;
